/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Form, Button, Spinner, Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import handleResponseError from '../../../../../utils/handleResponseError';
import FreightRateHttpService from '../../../../../services/http/freight-rate-http';

interface FreightRateForm {
    stateAcronym: string;
    valueLimit: number;
    rate: number;
}

interface FreightRateModalProps {
    isEdit: boolean;
    selectedRate: any;
    update: () => void;
    isOpen: (value: boolean) => void;
    onHide: () => void;
    show: boolean;
}

const FreightRateModal = ({
    isEdit,
    selectedRate,
    update,
    isOpen,
    onHide,
    show
}: FreightRateModalProps) => {
    const [loading, setLoading] = useState(false);

    const {
        control,
        watch,
        reset,
        setValue,
    } = useForm<FreightRateForm>({
        shouldUnregister: false,
        defaultValues: {
            stateAcronym: '',
            valueLimit: 0,
            rate: 0,
        },
    });

    const fieldsData = watch();

    const createRate = async () => {
        setLoading(true);
        try {
            const payload = {
                stateAcronym: fieldsData.stateAcronym.toUpperCase(),
                valueLimit: Number(fieldsData.valueLimit),
                rate: Number(fieldsData.rate),
            };

            const response = await FreightRateHttpService.saveFreightRate(payload);

            if (response) {
                update();
                isOpen(false);

                toast.success(
                    'Faixa de frete cadastrada com sucesso!'
                );
            }
        } catch (err: any) {
            handleResponseError(
                err,
                'Ocorreu um erro ao salvar a faixa de frete.'
            );
        } finally {
            setLoading(false);
        }
    };

    const editRate = async () => {
        setLoading(true);

        try {
            const payload = {
                id: selectedRate.id,
                stateAcronym: fieldsData.stateAcronym.toUpperCase(),
                valueLimit: Number(fieldsData.valueLimit),
                rate: Number(fieldsData.rate),
            };

            const response = await FreightRateHttpService.editFreightRate(payload);

            if (response) {
                update();
                isOpen(false);

                toast.success(
                    'Faixa de frete atualizada com sucesso!'
                );
            }
        } catch (err: any) {
            handleResponseError(
                err,
                'Ocorreu um erro ao atualizar a faixa de frete.'
            );
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (!isEdit) {
            reset({
                stateAcronym: '',
                valueLimit: 0,
                rate: 0,
            });
        }else{
            setValue( 'stateAcronym', selectedRate.stateAcronym || '' );
            setValue( 'valueLimit', selectedRate.valueLimit || 0 );
            setValue( 'rate', selectedRate.rate || 0 );
        }
    }, [show, isEdit, reset]);

    return (
        <Modal
            className="modal-dialog-scrollable"
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title
                    className="ml-3 mr-3"
                    id="contained-modal-title-vcenter"
                >
                    {isEdit
                        ? 'Editar faixa de frete'
                        : 'Nova faixa de frete'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="w-100">

                <Form.Group controlId="stateAcronym">
                    <Form.Label>UF</Form.Label>

                    <Controller
                        control={control}
                        name="stateAcronym"
                        rules={{
                            required: 'Campo obrigatório',
                            maxLength: 2,
                        }}
                        render={({ value, onChange }) => (
                            <Form.Control
                                type="text"
                                maxLength={2}
                                value={value}
                                onChange={(e) =>
                                    onChange(
                                        e.target.value.toUpperCase()
                                    )
                                }
                                placeholder=""
                            />
                        )}
                    />
                </Form.Group>

                <Form.Group controlId="valueLimit">
                    <Form.Label>Valor Limite (R$)</Form.Label>

                    <Controller
                        control={control}
                        name="valueLimit"
                        rules={{
                            required: 'Campo obrigatório',
                        }}
                        render={({ value, onChange }) => (
                            <Form.Control
                                type="number"
                                min={0}
                                step="0.01"
                                value={value}
                                onChange={onChange}
                            />
                        )}
                    />
                </Form.Group>

                <Form.Group controlId="rate">
                    <Form.Label>Taxa de Frete (%)</Form.Label>

                    <Controller
                        control={control}
                        name="rate"
                        rules={{
                            required: 'Campo obrigatório',
                        }}
                        render={({ value, onChange }) => (
                            <Form.Control
                                type="number"
                                min={0}
                                step="0.01"
                                value={value}
                                onChange={onChange}
                            />
                        )}
                    />
                </Form.Group>

            </Modal.Body>

            <Modal.Footer className="ml-3 mr-3 mb-2">
                <Button
                    variant="outline-primary"
                    style={{ width: '150px' }}
                    onClick={() => {
                        reset();
                        isOpen(false);
                    }}
                >
                    Cancelar
                </Button>

                <Button
                    style={{ width: '150px' }}
                    onClick={
                        isEdit
                            ? editRate
                            : createRate
                    }
                >
                    {loading ? (
                        <Spinner animation="border" />
                    ) : (
                        'Salvar'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FreightRateModal;